import "./lib/sentry";
import "./lib/captcha";
import "./lib/api";

import { HeroUIProvider } from "@heroui/react";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "next-themes";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import { printBanner } from "./lib/banner";

let ErrorBoundary = ({ children }: React.PropsWithChildren) => <>{children}</>;

if (__SENTRY_DSN__) {
  ErrorBoundary = ({ children }) => {
    return <Sentry.ErrorBoundary showDialog>{children}</Sentry.ErrorBoundary>;
  };
}

printBanner();

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HeroUIProvider>
        <ThemeProvider attribute="class" defaultTheme="system">
          <App />
        </ThemeProvider>
      </HeroUIProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
